// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateURLWithFilters = <T extends Record<string, any>>(
  filters: T | undefined,
  url: string
): string => {
  if (!filters) {
    return url;
  }

  const queryString = Object.keys(filters)
    .filter(
      key =>
        filters[key] !== undefined &&
        filters[key] !== null &&
        filters[key] !== ''
    )
    .flatMap(key => {
      const value = filters[key];

      if (Array.isArray(value)) {
        return value.map(
          item =>
            `filter%5B${encodeURIComponent(key)}%5D%5B%5D=${encodeURIComponent(
              String(item)
            )}`
        );
      }
      return `filter%5B${encodeURIComponent(key)}%5D=${encodeURIComponent(
        String(value)
      )}`;
    })
    .join('&');

  const separator = url.includes('?') ? '&' : '?';

  return queryString ? `${url}${separator}${queryString}` : url;
};

/**
 * Certificate status validation utilities
 */
export const CertificateStatusValidator = {
  isPending: (status: string) => status === 'pending',
  isIssued: (status: string) => status === 'issued',
  isReadyForIssue: (status: string) => status === 'ready_for_issue',
  isApproved: (status: string) => status === 'approved',
  isRejected: (status: string) => status === 'rejected',
  isWaiting: (status: string) => status === 'waiting'
} as const;
